module.exports = __webpack_public_path__ + "img/nagano.edcc6348.png";